import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/frontru/aquaart-group/src/views/academy/index.tsx");
